import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  mainContainer: {
    marginHorizontal: 20,
  },
  mainHeaderContainer: {
    flex: 1,
    marginRight: 10,
  },
  countBox: {
    paddingHorizontal: 15,
    borderRadius: 50,
    paddingVertical: 2.5,
  },
  divider: {
    // marginVertical: 15,
  },
  parentBox: {
    flex: 1,
  },
  iconStyle: {
    marginRight: 10,
  },
  refreshControl: {zIndex: 100},
  skeletonContainer: {marginHorizontal: 20},
  alertBox: {
    paddingHorizontal: 10,
    paddingTop: 10,
  },
  skipContainer: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    marginHorizontal: 20,
    borderRadius: 5,
    marginVertical: 10,
  },
  skipButton: {
    height: 25,
    width: 70,
  },
  container: {
    marginBottom: 15,
    paddingRight: 15,
    justifyContent: 'space-between',
    width: '100%',
    paddingVertical: 10,
    paddingHorizontal: 15,
  },
  updateTypo: {
    textAlign: 'left',
  },
});
